// Import packages
import React, {Component} from "react";
import {connect} from "react-redux";

//import styles
import '../../assets/styles/containerStyles/about.scss';

// Import components
import PageWrapper from '../../components/pageContentViews/pageWrapper'
import {InputGroup} from "../../components/uiElements/inputGroup";
import {LinkButton} from "../../components/buttons/buttons";
import {LanguageTabs} from "../../components/uiElements/Tabs";

// Import utils
import {
    changeStateField,
    getInputValues, getPatchReqData,
    getTranslatableInputValues, getTranslationData,
    initTranslations,
} from "../../utils/helperFunctions";
import {mapStateToProps} from "../../redux/mapStateToProps";
import {
    GetInfoData,
    UpdateInfoData
} from "../../redux/actions";
import {validateTranslations} from "../../utils/validateTranslations";
import {NestableItem} from "../../components/cards/nestableItem";
import Nestable from "react-nestable";

class Info extends Component {
    constructor(props) {
        super(props);
        this.translationsFields = [
            'title',
            'description'
        ];
        this.state = {
            fieldsData: {
                translations: initTranslations(this.translationsFields, props.activeLanguages),
                blocks: [],
            },
            errors: {},
            errorsTabs: [],
            languageTab: props.mainLanguage,
            requestLoading: false,
            isEditing: true,
        };
        this.updatedDataMap = new Map();
        this.currentData = null;
        this.changeLanguageTab = changeStateField.bind(this, 'languageTab');
        this.getInputValues = getInputValues.bind(this);
        this.getPatchReqData = getPatchReqData.bind(this);
        this.getTranslationValues = getTranslatableInputValues.bind(this);
        this.onPositionChange = this.onPositionChange.bind(this);
        this.updateInfo = this.updateInfo.bind(this);

    }

    async componentDidMount() {
        await this.props.GetInfoData();
        const {infoData} = this.props;
        if (infoData) {
            const {fieldsData} = this.state;
            const translationsData = {};

            if (infoData) {
                Object.keys(fieldsData.translations).forEach(key => {
                    const trItem = infoData?.translations.find(item => item.language === key);
                    translationsData[key] = {
                        ...fieldsData.translations[key],
                        title: trItem?.title || '',
                        description: trItem?.description || '',
                    };
                });
            }
            const initStateData = {
                translations: translationsData,
            }
            this.currentData = JSON.parse(JSON.stringify(initStateData));
            this.setState({
                fieldsData: initStateData,
                errors: {},
                errorsTabs: [],
                requestLoading: false,
            });

        }
    }

    async updateInfo() {
        await this.setState({
            requestLoading: true
        });
        const {translations} = this.state.fieldsData;
        const translationRequiredFields = ['title', 'description'];
        const validationTr = validateTranslations(translations, translationRequiredFields);
        let result = validationTr.result;
        const errors = {...validationTr.errors};
        if (result) {
            const reqData = {
                translations: getTranslationData(translations)
            };
            this.props.UpdateInfoData(reqData).then(() => {
                this.updatedDataMap.clear();
            }).catch(() => {
            }).finally(() => {
                this.setState({requestLoading: false});
            });
        } else {
            this.setState({
                requestLoading: false,
                errors: errors,
                errorsTabs: validationTr.errorsTabs
            })
        }

    }

    getNestableItems(list) {
        const items = [];
        list && !!list.length && list.map((item) => {
            items.push({
                id: item?.id,
                title: item?.title,
                withImage: true,
                path: item?.mediaMain?.path,
                link: {
                    pathname: `/info/block/edit/${item?.id}`,
                },
                data: item,
                children: []
            })
        });
        return items;
    }

    onPositionChange(items) {
        const blocks = items.map(item => item.data);

        const reqData = {
            blocks: blocks.map(block => {
                return {
                    ...block,
                    mediaMain: block?.mediaMain?.id || null,
                    icon: block?.icon?.id || null,
                }
            })
        }
        this.props.UpdateInfoData(reqData)
    }

    render() {
        const {
            fieldsData,
            errors,
            languageTab,
            requestLoading,
            errorsTabs
        } = this.state;
        const {infoData} = this.props;
        const initData = this.currentData?.translations[languageTab] || {};
        const currentData = fieldsData.translations[languageTab] || {};

        let items = this.getNestableItems(infoData?.blocks);
        return <PageWrapper pageTitle={'Տեղեկատվություն'}>

            <section className="about">
                <div className="info-wrapper">
                    <LanguageTabs changeLanguageTab={this.changeLanguageTab}
                                  errorsTabs={errorsTabs}
                                  activeTab={languageTab}/>
                    <InputGroup inputType="input"
                                type="text"
                                label="Գլխավոր էջի վերնագիր"
                                placeholder="Վերնագիր"
                                name="title"
                                value={currentData.title}
                                initValue={initData.title}
                                error={errors['title' + languageTab]}
                                required={true}
                                onChange={this.getTranslationValues}/>
                    <InputGroup inputType="textarea"
                                type="text"
                                label="Գլխավոր էջի նկարագրությունը"
                                placeholder="նկարագրությունը"
                                name="description"
                                value={currentData.description}
                                initValue={initData.description}
                                error={errors['description' + languageTab]}
                                maxLength={1000}
                                required={true}
                                onChange={this.getTranslationValues}/>
                </div>

                <div className="flex-wrapper-right">
                    <LinkButton title={'Փոփոխել'}
                                loading={requestLoading}
                                disabled={!this.updatedDataMap.size}
                                cb={this.updateInfo}/>
                </div>
                <div>
                    <label className={'list-label'}>Բաժիններ</label>

                    <Nestable
                        items={items}
                        maxDepth={1}
                        onChange={this.onPositionChange}
                        renderItem={NestableItem}
                    />

                </div>
            </section>
        </PageWrapper>
    }
}

const mapDispatchToProps = {
    GetInfoData,
    UpdateInfoData,
};

export default connect(mapStateToProps, mapDispatchToProps)(Info)
